<template>
  <div class="error-block">
    <i class="error-block__icon icon-error-warning-line t-iconfont"></i>
    <span class="error-block__text">{{ text }}</span>
  </div>
</template>

<script setup>
defineOptions({
  name: 'ErrorBlock'
})

defineProps({
  text: {
    type: String,
    default: ''
  }
})
</script>

<style lang="scss" scoped>
.error-block {
  display: flex;
  align-items: flex-start;
  color: #f54e4e;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;

  &__icon {
    flex: none;
    margin-right: 6px;
    font-size: 16px;
    line-height: 22px;
  }

  &__text {
    min-width: 0;
    word-break: break-word;
  }
}
</style>
